export default __webpack_public_path__ + "static/media/SuperAdmin.6a4b7c1d.svg";